/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */

import { BlackMostrosMenu } from './blackmostros.menu.js';
import { BlackMostrosPathway } from './blackmostros.pathway.js';
import {
  set_css_props,
  console_if_debug,
  } from './blackmostros.method.js';

// export default obj => {
//   return new Promise((resolve, reject) => {
//     // ~ console.log('obj:', obj);
//     resolve(BlackMostrosHeader(obj));
//     // ~ let _bmh = BlackMostrosHeader();
//     // ~ resolve(_bmh);
//     reject('bad');
//     });
//   };

let BlackMostrosHeader = (function(
  $,
  // ~ _q  // to remove
  ){
  /*
   * this object handles all page header elements
   *
   */
  var _menuid,
    _showinres = 801,
    _mbuttonres,
    _showmbinres, // show mobile button in res
    $mfheight = "32px",
    $hfheight = "130px",
    $hrheight = "130px",
    displayed = false,
    _fixed = false,
    _header,
    _menu,
    _pathw,
    _topmenu,
    _top_menu_id = 'topmenu',
    _scroll_top_id,
    _w,
    _h,
    $treemenu,
    $islevel1,
    _win=window,
    _sel={
      close_icon: "i_minus",
      // ~ close_icon: "glyphicon-minus",

      },
    mpublic = {};

  /*
   * load requirements and init
   *
   */
  function _get_requirements(){
  // ~ async function _get_requirements(){

    /*
     * set blackmostros menu
     *
     */
    _menu = BlackMostrosMenu($);
    // ~ _menu = await BlackMostrosMenu($);

    /*
     * set blackmostros pathway
     *
     */
    _pathw = BlackMostrosPathway($);
    // ~ _pathw = await BlackMostrosPathway($);

    }
  _get_requirements();

  function _scroll_to_top(){
    _win.scrollTo(0, 0);
  }

  function _init (
    props
    //~ headerid, menuid, showinres, mbuttonres, mfheight, hfheight, hrheight, pathwayid,
  ){
    _menuid = props._menuid;
    _showinres = props._showinres;
    _mbuttonres = props._mbuttonres;
    // ~ _mfheight = props._mfheight;
    // ~ _hfheight = props._hfheight;
    // ~ _hrheight = props._hrheight;
    // ~ _scroll_top_id = props._scrolltotopid;

    // set screen size
    _update_width_height();

    // header
    _header = $.getElementById(props._headerid);
    // ~ _header = $(props._headerid);

    // scroll to top button
    // ~ _scrolltop = $.getElementById(_scroll_top_id);
    // ~ _scrolltop.addEventListener('click', _scroll_to_top);
    /*
    _scrolltop = $(_scroll_top_id);
    _scrolltop.on('click', _scroll_to_top);
    */
    // ~ console.log('one', _scrolltop);

    /*
     * menu
     * need event listeners for open/close menu level-1
     * for desktop screen size, else hide mobile menu
     * make this in BlackMostros
     *
     */
    // ~ _menu = new BlackMostrosMenu($);
    // ~ console.log(_menuid, props._mbuttonres);
    _menu.init(_menuid, props._mbuttonres);

    // pathway
    // ~ _pathw = new BlackMostrosPathway($);
    _pathw.init(props._pathwayid, {
      // need calculate top to maintain pathway visibility
      'top': '164px',
      'z-index': '0'
      });

    // banners
    //~ _banners = new BlackMostrosBanners($);
    //~ _banners.add(_topbannerid);

    console_if_debug('Blackmostros header ready...');
    // ~ console.log('Blackmostros header ready...');
  }
  mpublic.init = _init;

  // set events handlers
  function _on (name, method){
    // ~ console.log('set event:', name, method, _header);
    _header.addEventListener(name, method);
    // ~ _header.on(name, method);
  }
  mpublic.on = _on;

  function _get_fixed_height(){
      let _re = _header.offsetHeight;
      // ~ let _re = _header.outerHeight(true); // + _pathw.get_height();
      return _re;
  }

  function _get_width() {
    /*
     * calculate current header width
     * if window width less than _showinres, get window width
     * else set in css.
     *
     */
    let _re = _header.offsetWidth;
    // ~ let _re = _header.outerWidth(true);
    if (_re > _w) {
      _re = '100%';
    }
    return _re
  }

  function _get_height() {
    /*
     * calculate current header height
     * if header is fixed:
     *    sum head + menu + pathway heights
     * else:
     *    0
     *
     */
    let _re;
    if (_fixed) {
      _re = _get_fixed_height();
    } else {
      _re = 0;
    }
    return _re;
  }

  mpublic.get_width = _get_width;

  mpublic.get_fixed_height = _get_fixed_height;

  mpublic.get_height = _get_height;

  function _fix() {
    /*
     * when fix a header, we need see if page have:
     *  pathway, top-banner
     * if exist, fix then.
     *
     */
    _fixed = true;
    var _top = _get_height()
    _pathw.fix({top: _top});
    set_css_props(_header, {
      "position": "fixed",
      "top": 0,
      });

    // _header.css({
    //   "position": "fixed",
    //   "top": 0,
    //   });

    //~ _fixed = true;
  }
  mpublic.fix = _fix;

  function _unfix() {
    _pathw.unfix();
    _header.style.position = "inherit";
    // ~ _header.css("position", "inherit");
    _fixed = false;
  }
  mpublic.unfix = _unfix;

  function _hide_menu() {
    /*
     * only hide level-1 elements if in desktop screens
     * size defined in _mbuttonres
     * else hide mobile menu
     *
     */
    if (_w >= _mbuttonres) {
      _menu.hide_menu();
    } else {
      _menu.hide_mobile_menu();
    }
  }
  mpublic.hide_menu = _hide_menu;

  /**
   * fix menu/header function
   * headheight depend on window width
   * if menu is shown, fix if > showinres
   *
   * unfix menu/header if change window width
   */
  function _fixheader() {
    displayed = true;
    mpublic.fixmenu("", "", 2);
  }
  mpublic.fixheader = _fixheader;

  function _unfix_header() {
    displayed = false;
    mpublic.fixmenu("", "", 2);
  }
  mpublic.unfixheader = _unfix_header;

  function _fixmenu($islevel1, $treemenu, state) {
    var _desktop_head_height = '104px',
      _mobile_head_height = "65px",
      _bodytop = "162px";

    function _is_treemenu_displayed(){
      var _re = true;
      if ($treemenu) {
        //~ if ($treemenu.attr('class').indexOf(" glyphicon-minus") === -1) {
        if ($treemenu.hasClass(
          _sel.close_icon
          // ~ "glyphicon-minus"
          )) {
          _re = false;
        } else {
          _re = true;
        }
      } else {
        _re = true;
      }
      return _re
    }

    if (state==0) {
      // for screen width > _showinres
      if (_w > _showinres && $islevel1.indexOf(" level-1") != -1) {
        displayed = _is_treemenu_displayed();
        fixheaderelements(_desktop_head_height, _bodytop);
      }
    } else if (state==2) {
      // for google search button
      // if displayed, hide treemenu
      if (_is_treemenu_displayed()) {
        displayed = true;
        hide_show_treemenu();
      }
      if (_w > _showinres) {
        fixheaderelements(_desktop_head_height, _bodytop);
      } else if (_w < _showinres) {
        // if show menu, calc header height change
        // else do nothing
        // get height from logoheader element
        fixheaderelements(_mobile_head_height, _desktop_head_height);
      }
    } else {
      // for screen width < _showinres
      if (_w < _showinres && displayed) {
        // if show menu, calc header height change
        // else do nothing
        // get height from logoheader element
        fixheaderelements(_mobile_head_height, _desktop_head_height);
      }
    }
  }
  mpublic.fixmenu = _fixmenu;

  function _update_width_height(){
    // ~ console.log($, _win);
    _w = _win.innerWidth;
    _h = _win.innerHeight;
    /*
    _w = $(window).width();
    _h = $(window).height();
    */
  }

  function _on_resize(event) {
    _update_width_height();
    mpublic.fixmenu("", "", 1);
  }
  window.onresize = _on_resize;

  /**
   * fix or unfix header elements
   *
   */
  function fixheaderelements($headheight, $bodytop) {
    // var $headheight = '104px';
    var $fixelement = [
      // element, fixposition, fixheight, relativeheight, fixtop, relativetop, fixmargin-top, relative-margin-top, fix-z-index, relative-z-index, fixwidth, relativeposition
      [$("#head"), "fixed", $hfheight, $hrheight, 0, 0],
      [$("#pathway"), "relative", '43px', "43px", 0, 0, "164px", 0, 100, 300],
      ],
      flen = $fixelement.length,
      $bancontent = $("#ban-content"),
      $pathway = $("#pathway");

    if (displayed === true) {
      // fix menu and header if menu is shown
      for (i = 0; i < flen; i++) {
        $fixelement[i][0].css("position", $fixelement[i][1]);
        $fixelement[i][0].css("top", $fixelement[i][4]);
        if ($fixelement[i].length > 6) {
          $fixelement[i][0].css("margin-top", $fixelement[i][6]);
          }
        if ($fixelement[i].length > 8) {
          $fixelement[i][0].css("z-index", $fixelement[i][8]);
          }
        }
      if ($pathway.length) {
        $bancontent.css("margin-top", "-2px");
      } else {
        $bancontent.css("margin-top", $bodytop);
      }
    } else {
      // unfix menu and header in width > _showinres
      for (i = 0; i < flen; i++) {
        $fixelement[i][0].css("position", "unset");
        $fixelement[i][0].css("top", $fixelement[i][5]);
        if ($fixelement[i].length > 7) {
          $fixelement[i][0].css("margin-top", $fixelement[i][7]);
          }
        if ($fixelement[i].length > 9) {
          $fixelement[i][0].css("z-index", $fixelement[i][9]);
          }
        }
      $bancontent.css("margin-top", "-2px");
      }

    }

  /**
   * on scroll events
   * do only on desktop screens
   */
  // change this for sticky, see https://developer.mozilla.org/docs/Mozilla/Performance/ScrollLinkedEffects
  //~ window.onscroll = function() {fixAdsFunction()};

  function fixAdsFunction() {
    var $headheight = 101,
      _w = $(window).width(),
      _h = $(window).height(),
      _e = document.getElementsByClassName("moduletable scroll-float")[0];

    if (_e) {
      var bodyRect = document.body.getBoundingClientRect(),
        elemRect = _e.getBoundingClientRect(),
        offset = elemRect.top - bodyRect.top,
        estarttop = 1096;

      if (_w > 760) {
        if (document.body.scrollTop > estarttop || document.documentElement.scrollTop > estarttop) {
          _e.className = "moduletable scroll-float fix";
        }
        else {
          _e.className = "moduletable scroll-float";
        }
      }
    }
  }


  /*
   * menu tree hide/show
   *
   */
  // menu tree
  // if screen resolution > _showinres fix topmenuwrap when show submenu
  function hide_show_treemenu(){
    // try get tree menu clicked, if undefined,
    // try get some dropdown tree element opened in level-1
    $islevel1 = $(this).parent().parent().attr('class');
    if ($islevel1) {
      $(this).parent().parent().children('ul.tree').toggle();
      $treemenu = $(this).children('span.glyphicon');
      $treemenu.toggleClass(
        _sel.close_icon
        // ~ "glyphicon-minus"
        );
      mpublic.fixmenu($islevel1, $treemenu, 0);
    } else {
      var _mnu = _topmenu.find(".dropdown.level-1");
      $treemenu = _mnu.children(".header-group")
        .children("label.tree-toggler")
        .children("span");
      $islevel1 = _mnu.attr("class");
      if ($treemenu.hasClass(
        _sel.close_icon
        // ~ "glyphicon-minus"
        )) {
        _mnu.children('ul.tree').toggle();
        $treemenu.toggleClass(
          _sel.close_icon
          // ~ "glyphicon-minus"
          );
        //~ mpublic.fixmenu($islevel1, $treemenu, 0);
      }
      //~ mpublic.fixmenu($islevel1, $treemenu, 0);
    }
  }

  /**
   * do next when document ready
   *
   */
  /*
	$(document).ready(function()
	{
    // set top menu
    _topmenu = $(_top_menu_id);
		$('*[rel=tooltip]').tooltip();

		// Turn radios into btn-group
		$('.radio.btn-group label').addClass('btn');

		$('fieldset.btn-group').each(function() {
			// Handle disabled, prevent clicks on the container, and add disabled style to each button
			if ($(this).prop('disabled')) {
				$(this).css('pointer-events', 'none').off('click');
				$(this).find('.btn').addClass('disabled');
			}
		});

		$(".btn-group label:not(.active)").click(function()
		{
			var label = $(this);
			var input = $('#' + label.attr('for'));

			if (!input.prop('checked')) {
				label.closest('.btn-group').find("label").removeClass('active btn-success btn-danger btn-primary');
				if (input.val() == '') {
					label.addClass('active btn-primary');
				} else if (input.val() == 0) {
					label.addClass('active btn-danger');
				} else {
					label.addClass('active btn-success');
				}
				input.prop('checked', true);
			}
		});
		$(".btn-group input[checked=checked]").each(function()
		{
			if ($(this).val() == '') {
				$("label[for=" + $(this).attr('id') + "]").addClass('active btn-primary');
			} else if ($(this).val() == 0) {
				$("label[for=" + $(this).attr('id') + "]").addClass('active btn-danger');
			} else {
				$("label[for=" + $(this).attr('id') + "]").addClass('active btn-success');
			}
		});

    // menu tree
    // if screen resolution > _showinres fix topmenuwrap when show submenu
    $('label.tree-toggler').click(hide_show_treemenu);

    /*
    // recover css styles for current resolution
    $.ajax({
      url:"style.css",
      dataType:"script",
      success:function(data){
        $("head").append("<style>" + data + "</style>");
        //loading complete code here
      },
      error:function(xhr){
        $("head").append("<style>/* error *//*</style>");
      }
    });
    */


    /*
     * google ads
     *
     */
    // one by each ad
    // repeat don't needed
    /*
    // uncomment this block after minimize code.
    (adsbygoogle = window.adsbygoogle || []).push({
      google_ad_client: "ca-pub-4551634866328770",
      enable_page_level_ads: true
      });
    */

    /*
    (adsbygoogle = window.adsbygoogle || []).onload = function () {
      [].forEach.call(document.getElementsByClassName('adsbygoogle'), function () {
        adsbygoogle.push({});
        })
      }
    */

  //~ })

  return mpublic;
});

export {
  BlackMostrosHeader,
  };
